import React from 'react';
import { LayersIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function VolumesSection() {
  return <section className="w-full bg-steel-950 px-6 py-16 sm:py-20" aria-labelledby="volumes-title" data-id="element-216" data-mp="cn7rwvqkkdzv">
      <div className="mx-auto max-w-5xl" data-id="element-217" data-mp="7qppw3mmitr8">
        <SectionHeading id="volumes-title" badge="Inside the core system" badgeIcon={LayersIcon} title={<>
              6 massive volumes of <Accent data-id="element-219" data-mp="3c45zhqqh219x">technical excellence</Accent>
            </>} data-id="element-218" data-mp="7nlfgoikf1s4" />

        <Reveal className="mt-10 overflow-hidden border border-white/[0.07]" data-id="element-220" data-mp="3c1tbavu4euof">
          <ol data-id="element-221" data-mp="3pwc6onbncxx8">
            {volumes.map(({
            icon: Icon,
            number,
            title,
            focus
          }) => <li key={number} className="group flex flex-col gap-1 border-b border-white/[0.07] bg-steel-900 px-5 py-5 transition-colors duration-150 ease-out last:border-b-0 hover:bg-steel-850 sm:grid sm:grid-cols-[5.5rem_1fr_1.15fr] sm:items-center sm:gap-6 sm:px-7" data-id="element-222" data-mp="2xeqd0mxz4i01">
                <span className="flex items-center gap-3" data-id="element-223" data-mp="29f8nn2w6vsy0">
                  <Icon className="h-5 w-5 text-circuit-400 transition-colors duration-150 ease-out group-hover:text-ember-400" aria-hidden="true" data-id="element-224" data-mp="2edjur5v3npcj" />
                  <span className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-225" data-mp="2j7o2vsg3q3f7">
                    Vol {number}
                  </span>
                </span>
                <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-ink-50" data-id="element-226" data-mp="1qiqymt8q675g">
                  {title}
                </h3>
                <p className="text-sm leading-relaxed text-ink-400" data-id="element-227" data-mp="20ekg8r1awqu3">{focus}</p>
              </li>)}
          </ol>
        </Reveal>
      </div>
    </section>;
}